import { useTranslation } from 'react-i18next'
import { alertText } from './alertText'

/**
 * The banners for whatever a project's rules flagged, most severe first.
 *
 * Rendering is driven entirely by the alert's `code` and `severity`, so a new
 * rule on the backend needs nothing here beyond its two i18n strings. An
 * unrecognised code still renders -- as its own code -- rather than vanishing,
 * because a warning nobody sees is worse than an ugly one.
 */
const TONES = {
  danger: 'bg-red-50 border-red-200 text-red-800',
  warning: 'bg-amber-50 border-amber-200 text-amber-800',
}

export default function ProjectAlerts({ alerts, onAlertClick, className = '' }) {
  const { t } = useTranslation('engineering')
  if (!alerts || alerts.length === 0) return null

  return (
    <div className={`space-y-2 ${className}`}>
      {alerts.map((alert, i) => {
        const tone = TONES[alert.severity] || TONES.warning
        const clickable = typeof onAlertClick === 'function'
        const Tag = clickable ? 'button' : 'div'
        return (
          <Tag
            key={`${alert.code}-${i}`}
            onClick={clickable ? () => onAlertClick(alert) : undefined}
            className={`w-full text-left rounded-xl border px-4 py-2.5 flex items-start gap-3 text-sm ${tone} ${
              clickable ? 'hover:brightness-95 transition-[filter]' : ''}`}
          >
            <span className="shrink-0">⚠</span>
            <span>{alertText(t, alert)}</span>
          </Tag>
        )
      })}
    </div>
  )
}
